import { Controller } from "@hotwired/stimulus";

function csrfToken() {
  return (document.querySelector('meta[name="csrf-token"]') || {}).content || "";
}

export default class extends Controller {
  static values = { url: String, pinnable: Boolean, tenantSlug: String };

  pin(event) {
    if (!this.pinnableValue) return;
    const { platform, username, text, timestamp } = event.params;
    fetch(`${this.urlValue}?tenant_slug=${encodeURIComponent(this.tenantSlugValue)}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json",
      },
      body: JSON.stringify({ platform, username, text, message_timestamp: timestamp }),
    }).catch((err) => console.error("[chat-pin] pin failed", err));
  }

  unpin(event) {
    if (!this.pinnableValue) return;
    const { id } = event.params;
    fetch(`${this.urlValue}/${id}?tenant_slug=${encodeURIComponent(this.tenantSlugValue)}`, {
      method: "DELETE",
      headers: {
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json",
      },
    }).catch((err) => console.error("[chat-pin] unpin failed", err));
  }
}
